import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  collapseAll(event) {
    event.preventDefault()
    this.element.querySelectorAll("[data-controller=expandable-row]").forEach((row) => {
      this.application.getControllerForElementAndIdentifier(row, "expandable-row").collapse()
    })
  }
}
